import { createClient } from '@supabase/supabase-js';


const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Al agregar <Database>, el autocompletado y las validaciones se activan
export const supabase = createClient(supabaseUrl, supabaseAnonKey);